if (!customElements.get('idw-product-description')) {
  const owners = new WeakMap();
  customElements.define('idw-product-description', class extends HTMLElement {
    connectedCallback() {
      if (this.active) return;
      this.info = this.closest('product-info');
      if (!this.info || this.info.dataset.productId !== this.dataset.productId || owners.has(this.info)) return;
      owners.set(this.info,this);
      this.active = true;
      this.records = [];
      this.sequence = 0;
      this.observer = new MutationObserver(() => this.schedule());
      this.observe();
      this.schedule();
    }
    disconnectedCallback() {
      if (!this.active) return;
      this.active = false;
      this.observer.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.records.forEach(record => this.restore(record));
      this.records = [];
      this.description = null;
      if (owners.get(this.info) === this) owners.delete(this.info);
    }
    observe() {
      if (this.active) this.observer.observe(this.info,{childList:true,subtree:true,characterData:true});
    }
    schedule() {
      if (!this.active || this.frame != null) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (!this.active || !this.isConnected) return;
        this.observer.disconnect();
        try { this.refresh(); } finally { this.observe(); }
      });
    }
    filmHeading(node) {
      return /^H[2-6]$/.test(node.tagName) && node.textContent.replace(/\s+/g,'') === '保護フィルムについて';
    }
    isBoundary(node) {
      return /^H[1-6]$/.test(node.tagName) || node.matches('section,article,header,footer,details,summary,table,form,script,style') ||
        Boolean(node.querySelector('h1,h2,h3,h4,h5,h6,section,article,details,summary,table,form,input,select,textarea,button,iframe,object,embed,[contenteditable="true"]'));
    }
    contentKind(node,hasCopy,hasMedia) {
      if (this.isBoundary(node)) return null;
      const text = node.textContent.trim();
      const images = node.matches('img') ? 1 : node.querySelectorAll('img').length;
      if (node.tagName === 'FIGURE' && images && hasCopy) return 'media';
      if (node.tagName === 'IMG' && hasCopy) return 'media';
      if (node.tagName === 'P' && images && !text && hasCopy) return 'media';
      if (node.tagName === 'P' && !images && (text.includes('保護フィルム') || (!hasMedia && text && hasCopy))) return 'copy';
      if (node.tagName === 'DIV' && /(?:^|\s)idw-(?:note|notice|common-box|border-box|gray-box|box)(?:\s|$)/.test(node.className) &&
          !images && text && (text.includes('保護フィルム') || hasCopy)) return 'copy';
      return null;
    }
    collect(heading) {
      const nodes = [heading];
      const kinds = new Map();
      let hasCopy = false, hasMedia = false;
      for (let next=heading.nextElementSibling, count=0; next && count<16; next=next.nextElementSibling,count++) {
        const kind = this.contentKind(next,hasCopy,hasMedia);
        if (!kind) break;
        if (kind === 'copy') hasCopy = true;
        if (kind === 'media') hasMedia = true;
        nodes.push(next); kinds.set(next,kind);
      }
      return hasCopy ? {nodes,kinds} : null;
    }
    mark(record,node,name) {
      record.classes.push({node,name,had:node.classList.contains(name),hadClass:node.hasAttribute('class')});
      node.classList.add(name);
    }
    enhance(heading,selection) {
      const parent = heading.parentElement;
      const exclusiveSection = parent.tagName === 'SECTION' && [...parent.children].every(node => selection.nodes.includes(node)) &&
        [...parent.childNodes].every(node => node.nodeType !== 3 || !node.textContent.trim());
      const record = {heading,nodes:selection.nodes,classes:[],moves:[],created:!exclusiveSection};
      const section = exclusiveSection ? parent : document.createElement('section');
      record.section = section;
      if (record.created) {
        heading.before(section);
        selection.nodes.forEach(node => {
          const marker = document.createComment('idw-description-film-origin');
          node.before(marker); record.moves.push({node,marker}); section.append(node);
        });
      }
      this.mark(record,section,'idw-description-film');
      this.mark(record,heading,'idw-description-film__heading');
      selection.kinds.forEach((kind,node) => this.mark(record,node,`idw-description-film__${kind}`));
      record.originalHeadingId = heading.getAttribute('id');
      record.originalLabelledby = section.getAttribute('aria-labelledby');
      if (!heading.id) {
        let id;
        do { id = `IdwFilm-${this.dataset.productId}-${++this.sequence}`; } while (document.getElementById(id));
        heading.id = id;
      }
      section.setAttribute('aria-labelledby',heading.id);
      this.records.push(record);
    }
    restore(record,restoreNodes = true) {
      if (record.created) {
        if (restoreNodes) record.moves.forEach(({node,marker}) => { if (marker.parentNode) marker.replaceWith(node); });
        else record.moves.forEach(({marker}) => marker.remove());
        record.section.remove();
      } else if (record.originalLabelledby == null) record.section.removeAttribute('aria-labelledby');
      else record.section.setAttribute('aria-labelledby',record.originalLabelledby);
      if (record.originalHeadingId == null) record.heading.removeAttribute('id');
      else record.heading.setAttribute('id',record.originalHeadingId);
      record.classes.forEach(({node,name,had,hadClass}) => {
        if (!had) node.classList.remove(name);
        if (!hadClass && !node.className) node.removeAttribute('class');
      });
    }
    refresh() {
      const description = this.info.querySelector('.product__description');
      if (description !== this.description) {
        this.records.forEach(record => this.restore(record));
        this.records = []; this.description = description;
      }
      if (!description) return;
      this.records = this.records.filter(record => {
        if (!description.contains(record.section)) { this.restore(record,false); return false; }
        if (!this.filmHeading(record.heading) || [...record.section.querySelectorAll('h1,h2,h3,h4,h5,h6')].some(node => node !== record.heading)) {
          this.restore(record); return false;
        }
        return true;
      });
      for (const heading of description.querySelectorAll('h2,h3,h4,h5,h6')) {
        if (!this.filmHeading(heading) || heading.closest('.idw-description-film,details,table')) continue;
        const selection = this.collect(heading);
        if (selection) this.enhance(heading,selection);
      }
    }
  });
}
